import React, {useState, useEffect, useCallback} from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import {
    Row,
    Col,
    Tabs,
    message,
    Card,
} from 'antd';
import ReviewProduct from '../ReviewForm/ReviewProductForm';
import PanoramaViewer from "../PanoramaViewer";
import { getBaseURL, ROOM_PANORAMA_ASSET_URI } from '../../../../environments/env';
const { TabPane } = Tabs;

const RoomDetails = (props) =>  {

    const childProps = props.props;

    const [isFullScreen, setIsFullScreen] = useState(false);

    const setFullScreen = (value) => {
        if (value == true){
            message.info('Press ESC to exit full screen');
        }
        setIsFullScreen(value);
    }

    useEffect(() => {
        window.dispatchEvent(new Event('resize'));
    }, [isFullScreen]);
    

    const onReject = (msg) => {
        childProps.updateRoom({
            room_id: props.itemId,
            model_status: "-5"
        });
    }

    const onApprove = () => {
        childProps.updateRoom({
            room_id: props.itemId,
            model_status: "5"
        });
    }


    const escFunction = useCallback((event) => {
        if(event.keyCode == 27) {
            setIsFullScreen(false);
        }
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, []);
        return <div>
                <Row type="flex" justify="space-around" gutter={12} >
                <Col span={24}>
                    
                    { ( childProps.roomReducer.room.three_sixties && childProps.roomReducer.room.three_sixties.length == 0) ?
                        <Card className={isFullScreen ? 'room-full-screen': 'room-viewer-normal'} bodyStyle={{padding: isFullScreen ?0:8}}>
                                <LegacyIcon style={{fontSize: 20, margin: -12, color: "#40a9ff"}} className="product-full-screen-icon" onClick={() => setFullScreen(!isFullScreen)} type={(isFullScreen) ? "fullscreen-exit":"fullscreen"} />
                                {childProps.roomReducer.isLoading ? <LegacyIcon className="model-pending-msg" type="sync" spin />: <div>
                                    {childProps.roomReducer.room.model_status == '2' ? <h3 className="model-pending-msg">Model will be ready by 24 hours.</h3>
                                    : ''}
                                </div>}
                                <PanoramaViewer id={'360Camera'} customClass={isFullScreen ? 'room-panorama-full-screen': 'room-panorama-view'} threeSixtyUrl={getBaseURL(childProps.roomReducer.room.platform) + ROOM_PANORAMA_ASSET_URI + props.itemId + '/360Camera.jpg'} />
                        </Card>
                        :
                        (childProps.roomReducer.room.three_sixties) ?
                            <Tabs
                                    tabBarStyle={{ 
                                    display: 'flex', 
                                    justifyContent: 'center' 
                                }}
                                defaultActiveKey='1'
                            >
                                {childProps.roomReducer.room.three_sixties.map((name, index) => (
                                    <TabPane tab={name.split(".")[0]} key={index + 1}>
                                        <Card className={isFullScreen ? 'room-full-screen': 'room-viewer-normal'} bodyStyle={{padding: isFullScreen ?0:8}}>
                                        <LegacyIcon style={{fontSize: 20, margin: -12, color: "#40a9ff"}} className="product-full-screen-icon" onClick={() => setFullScreen(!isFullScreen)} type={(isFullScreen) ? "fullscreen-exit":"fullscreen"} />
                                            {childProps.roomReducer.isLoading ? <LegacyIcon className="model-pending-msg" type="sync" spin />: <div>
                                                {childProps.roomReducer.room.model_status == '2' ? <h3 className="model-pending-msg">Model will be ready by 24 hours.</h3>
                                                : ''}
                                            </div>}
                                            <PanoramaViewer id={name} customClass={isFullScreen ? 'room-panorama-full-screen': 'room-panorama-view'} threeSixtyUrl={getBaseURL(childProps.roomReducer.room.platform) + ROOM_PANORAMA_ASSET_URI + props.itemId + '/' + name} />
                                        </Card>
                                    </TabPane>
                                ))}
                                
                            </Tabs>
                            :
                            ""
                    }

                    <Row type="flex" style={{justifyContent: "space-between", marginTop: "15px"}}>
                        <h3>{childProps.roomReducer.room.room_name}</h3>
                        <h4>ID: {props.itemId}</h4>
                    </Row>

                    <Row type="flex" style={{justifyContent: "space-between", marginTop: "0px"}}>
                        <h5> {childProps.roomReducer.room.category}</h5>
                    </Row>
                    <hr/>
                </Col>
                
                </Row>
            {childProps.roomReducer.room.model_status == "4" ? <ReviewProduct adminForm={false} roomDetail={false} roomDetailModal={true} onApprove={onApprove} onReject ={onReject} platform={childProps.roomReducer.room.platform}></ReviewProduct> : ''}
            </div>


}

export default RoomDetails;